<template>
	<div>
		<CCard>
			<CCardHeader> 2) Saissisez les bordereaux à lier au point de vente </CCardHeader>
			<CCardBody v-if="!finalPage && data != null">
				<h4>[{{ data.reference }}] {{ data.name }}</h4>
				<h4 class="mb-5">({{ inputs.length }}) Bordereaux</h4>

				<form ref="mainForm" action="/api/slips/multiple" method="post" axiosMethod="post">
					<input type="hidden" name="pointOfSale" :value="data['@id']" />

					<CRow v-for="item in inputs" :key="item.id">
						<CCol md="5">
							<div class="form-group">
								<input
									:ref="`identifiers[${item.id}]`"
									:name="`identifiers[]`"
									class="form-control"
									placeholder="Numéro bordereau"
									@input="onIdentifierTyping($event)"
									maxlength="11" />
							</div>
						</CCol>
						<CCol sm="2">
							<CButton color="primary mr-2" @click="append">+</CButton>
							<CButton color="primary" @click="remove(item.id)">-</CButton>
						</CCol>
					</CRow>

					<CRow class="mt-4">
						<CCol col="6">
							<h4>({{ inputs.length }}) Bordereaux</h4>
						</CCol>
						<CCol md="6" class="text-right" v-if="!loading">
							<CButton color="primary" @click="onSubmit"> Valider </CButton>
						</CCol>
						<CCol md="12" class="text-right" v-if="loading">
							<Loading />
						</CCol>
					</CRow>
				</form>
			</CCardBody>

			<CCardBody v-if="finalPage">
				<h4 class="mb-5">[{{ data.reference }}] {{ data.name }}</h4>
				<h5>Vos bordereaux ont été enregistrés.</h5>
				<CButton color="primary" @click="download">Télécharger le bon de livraison</CButton>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import Loading from '../../../components/loading';
	import { last, remove } from 'lodash';

	export default {
		name: 'link-point-of-sale',

		components: {
			Loading,
		},

		data() {
			return {
				loading: true,
				finalPage: false,
				data: null,
				inputs: [{ id: 0 }],
				pdfUrl: null,
			};
		},

		mounted() {
			this.$axios.get(this.$route.params.id).then(res => {
				this.data = res.data;
				this.loading = false;
			});
		},

		methods: {
			onSubmit() {
				this.loading = true;

				this.$formDataToApi
					.sendForm(this.$refs.mainForm)
					.then(res => {
						this.loading = false;

						if (res.status === 200 || res.status === 201) {
							this.$toast.success('Liés avec succès !');
							this.finalPage = true;
							this.pdfUrl = res.data.slipHistory;
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},

			append() {
				this.inputs.push({ id: last(this.inputs).id + 1 });
			},

			remove(id) {
				if (this.inputs.length > 1) {
					this.inputs = remove(this.inputs, function (value) {
						return value.id !== id;
					});
				} else {
					this.$toast.error('Vous devez ajouter au moins un bordereau');
				}
			},

			async onIdentifierTyping($event) {
				this.$debounce(async () => {
					if ($event.target.value.length >= 11) {
						// regex check the slip value
						if (!$event.target.value.match('^[A-Za-z]{2,2}[0-9]{9,9}$')) {
							this.$formDataToApi.addMessageOnFormElement(
								$event.target,
								'Ce format de bordereau est invalide.'
							);
							return false;
						}

						// check if identifier is valid
						try {
							await this.$axios.get(`/api/slips/${$event.target.value}`).then(res => {
								this.$formDataToApi.addMessageOnFormElement(
									$event.target,
									'Ce bordereau est déjà lié à un point de vente.'
								);
								throw 'Déjà lié à un point de vente';
							});
						} catch (err) {
							if (err === 'Déjà lié à un point de vente') {
								return false;
							}
						}

						// check if identifier has been typed twice
						try {
							let counter = 0;
							for (let input of this.inputs) {
								let elems = this.$refs[`identifiers[${input.id}]`];
								if (elems && elems.length > 0 && elems[0].value === $event.target.value) {
									if (counter > 0) {
										this.$formDataToApi.addMessageOnFormElement(
											$event.target,
											`Ce bordereau a été saisie ${counter + 1} fois.`
										);
									}
									counter++;
								}
							}

							if (counter > 1) {
								throw 'Bordereau déjà saisie plusieurs fois';
							}
						} catch (err) {
							return false;
						}

						// append & focus on new input automatically
						await this.append();
						const lastInputId = last(this.inputs).id;
						const lastInputElem = this.$refs[`identifiers[${lastInputId}]`];

						if (lastInputElem != null && lastInputElem.length > 0) {
							lastInputElem[0].focus();
						}

						// clear precedent errors
						$event.target.classList.remove('is-invalid');
					}
				}, 300);
			},

			download() {
				this.$axios
					.get(this.pdfUrl, { responseType: 'blob' })
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
						});
					});
			},
		},
	};
</script>
